// src/app/template-ref.service.ts
import { Injectable, TemplateRef } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TemplateRefBulletinService {
  private bulletinPopup: TemplateRef<any>;

  setBulletinPopup(templateRef: TemplateRef<any>) {
    this.bulletinPopup = templateRef;
  }

  getBulletinPopup(): TemplateRef<any> {
    return this.bulletinPopup;
  }
}
